import type { OrganizationDetail } from '@/definitions/organization'
import {
  PRODUCT_FLAG_ROWS,
  type ProductFlagTier,
  SELECTABLE_TIERS,
  TIER_RANK,
} from '@/definitions/productFlags'

/**
 * Which package an organization is on, judged from what it has switched on.
 *
 * No tier is stored, so it is inferred: the highest package with anything on. An
 * organization with nothing on is on no package, and returns null — settling on the
 * lowest one instead would claim it has Core product flags when it has none, and would
 * put a "Current" badge on a package nobody chose.
 *
 * Manual switches are ignored because they belong to no package: an organization
 * with only Stripe on is still on no package.
 */
export const deriveSelectedTier = (org: OrganizationDetail): ProductFlagTier | null => {
  let highest: ProductFlagTier | null = null

  for (const row of PRODUCT_FLAG_ROWS) {
    if (row.tier === 'manual' || !SELECTABLE_TIERS.includes(row.tier)) {
      continue
    }
    if (highest !== null && TIER_RANK[row.tier] <= TIER_RANK[highest]) {
      continue
    }

    if (org[row.field] === true) {
      highest = row.tier
    }
  }

  return highest
}
